<div class="flex items-center justify-center h-screen">
  <div
    class="flex flex-col items-start justify-center max-w-md w-full rounded-xl p-4"
    >
    <img
      class="w-48 h-auto mx-auto mb-6"
      [ngSrc]="
        isLightMode()
          ? '../../../../assets/icons/logo-j-connected_blue_2.png'
          : '../../../../assets/icons/logo-j-connected_white.png'
      "
      height="79"
      width="190"
      alt="Johnston's Connected"
      priority
      />
      <h1 class="text-2xl">Reset your password</h1>
      <p class="text-xs text-gray-400 mb-2">
        Enter the email address associated with your account
      </p>
      <form
        [formGroup]="forgotPasswordForm"
        (ngSubmit)="onSubmit()"
        class="flex flex-col items-start justify-center max-w-md w-full rounded-xl"
        >
        <mat-form-field class="w-full">
          <mat-label>Email</mat-label>
          <input
            type="email"
            matInput
            placeholder="your@email.com"
            formControlName="email"
            />
            @if (forgotPasswordForm.get('email')?.hasError('required')) {
              <mat-error
                >
                Email is required.
              </mat-error>
            }
          </mat-form-field>
          <button
            type="submit"
            class="bg-custom-orange text-white text-md p-3 rounded-xl my-4 w-full"
            >
            Send
          </button>
        </form>
      </div>
    </div>
